import { employeesService } from "@services/employee-service";
import { useMutation } from "react-query";

export const usePostDocumentsQuery = () => {
  return useMutation((id: number | number[]) =>
    employeesService.moveToSign(id)
  );
};
